import { render } from "./Team.vue?vue&type=template&id=3c137f17"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=3c137f17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Team.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c137f17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c137f17', __exports__)) {
    api.reload('3c137f17', __exports__)
  }
  
  module.hot.accept("./Team.vue?vue&type=template&id=3c137f17", () => {
    api.rerender('3c137f17', render)
  })

}


export default __exports__